import React from 'react'
import { makeStyles } from '@material-ui/core'
import { useClient } from '../../../api/clients'
import { useResearchViewContext } from './ResearchViewProvider'

const useStyles = makeStyles((theme) => ({
  badge: {
    display: 'inline-block'
  },
  badgeContent: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: '6px 8px',
    margin: '-6px 0',
    backgroundColor: 'var(--color-primary-500)',
    color: 'var(--color-primary-050)',
    borderRadius: 'var(--border-radius-xs)',
    fontSize: '1rem'
  }
}))

const ClientNameDisplay = () => {
  const classes = useStyles()
  const { clientId } = useResearchViewContext()
  const { data: client, isLoading } = useClient(clientId, { enabled: !!clientId })

  return (
    <div className={classes.badge}>
      <div className={classes.badgeContent}>
        {isLoading ? (
          <>
            Loading...
          </>
        ) : client?.longName}
      </div>
    </div>
  )
}

export default ClientNameDisplay
